import React, { useContext, useEffect, useState } from "react";
import { useCabineContext } from "../../../context/CabineContext";
import Axios from "../../../_services/caller.service";
import styles from "./UpdateFeatures.module.scss";
import { GiMushroomCloud, GiOverkill } from "react-icons/gi";

import Modal from "../../UiComponents/modals/Modal";
import useModal from "../../../hooks/useModal";
import InputForms from "../../UiComponents/forms/InputForms";
import Button from "../../UiComponents/Button";
import InputPassword from "../../UiComponents/forms/InputPassword";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { use } from "react";
import NavContext from "../../../context/NavContext";
import { PermissionGate } from "../managePermissions/PermissionGate";

const UpdateFeatures = ({
  cabId,
  majCabine,
  setMajCabine,
  levelLog,
  changeLevelLog,
}) => {
  const { t } = useTranslation();
  const { cabine } = useCabineContext(); //all cabine owner
  const { ownerProfile, realOwnerProfile, setRealOwnerProfile } =
    useContext(NavContext);
  const [updateNextStart, setUpdateNextStart] = useState(false);
  const [forceRepairOnQuit, setForceRepairOnQuit] = useState(false);
  const [showBridge, setShowBridge] = useState(false);
  const [DeleteDiracLicence, setDiracDeleteLicense] = useState(false);
  const [showDetector, setShowDetector] = useState(false);
  const [allowDebugPath, setAllowDebugPath] = useState(false);
  const [killSwitch, setKillSwitch] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);

  const { isShowing, toggle } = useModal();

  //KILL SWITCH
  const [passwordAdmin, setPassWordAdmin] = useState("");

  const [showFunctionAtomic, setShowFunctionAtomic] = useState(false);

  //CONTROLLER
  const controller = new AbortController();
  const signal = controller.signal;

  // GET UPDATE NEXT START
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/UpdateNextStart/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "UpdateNextStart none") {
            setUpdateNextStart(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setUpdateNextStart(true);
            } else {
              setUpdateNextStart(false);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);

  // GET FORCE REPAIR ON QUIT
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/ForceRepairOnQuit/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "ForceRepairOnQuit none") {
            setForceRepairOnQuit(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setForceRepairOnQuit(true);
            } else {
              setForceRepairOnQuit(false);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);

  // GET SHOW BRIDGE
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/ShowBridge/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "ShowBridge none") {
            setShowBridge(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setShowBridge(true);
            } else {
              setShowBridge(false);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);

  // GET SHOW DECTECTOR
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/ShowDetector/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "ShowDetector none") {
            setShowDetector(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setShowDetector(true);
            } else {
              setShowDetector(false);
            }
          }
        })
        .catch(function (error) {
          //  console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);
  // GET ALLOW DEBUG PATH
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/AllowDebugPath/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "AllowDebugPath none") {
            setAllowDebugPath(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setAllowDebugPath(true);
            } else {
              setAllowDebugPath(false);
            }
          }
        })
        .catch(function (error) {
          //  console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);
  // GET DELETE DIRAC LICENCE
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/DeleteDiracLicence/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "DeleteDiracLicence none") {
            setDiracDeleteLicense(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setDiracDeleteLicense(true);
            } else {
              setDiracDeleteLicense(false);
            }
          }
        })
        .catch(function (error) {
          //  console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);

  // GET KILLSWITCH
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/KillSwitch/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "KillSwitch none") {
            setKillSwitch(false);

            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setKillSwitch(true);
            } else {
              setKillSwitch(false);
            }
          }
        })
        .catch(function (error) {
          //  console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);

  //UPDATE NEXT CALIB
  const setUpdateNextStartInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setUpdateNextStart/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setUpdateNextStart(true);
              } else {
                setUpdateNextStart(false);
              }
              toast.success(t("features.feature_enabled", { feature: "AskUpdate" }));
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "AskUpdate" }));
            });
        } else {
          Axios.put(`/setUpdateNextStart/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setUpdateNextStart(true);
              } else {
                setUpdateNextStart(false);
              }
              toast.success(t("features.feature_disabled", { feature: "AskUpdate" }));
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "AskUpdate" }));
            });
        }
      })
      .catch((error) => {});
  };
  //FORCE REPAIR ON QUIT
  const setForceRepairOnQuitInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setForceRepairOnQuit/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setForceRepairOnQuit(true);
              } else {
                setForceRepairOnQuit(false);
              }
              toast.success(t("features.feature_enabled", { feature: "ForceRepairOnQuit" }));
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "ForceRepairOnQuit" }));
            });
        } else {
          Axios.put(`/setForceRepairOnQuit/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setForceRepairOnQuit(true);
              } else {
                setForceRepairOnQuit(false);
              }
              toast.success(t("features.feature_disabled", { feature: "ForceRepairOnQuit" }));
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "ForceRepairOnQuit" }));
            });
        }
      })
      .catch((error) => {});
  };

  const setShowBridgeInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setShowBridge/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setShowBridge(true);
              } else {
                setShowBridge(false);
              }
              toast.success(t("features.feature_enabled", { feature: "ShowBridge" }));
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "ShowBridge" }));
            });
        } else {
          Axios.put(`/setShowBridge/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setShowBridge(true);
              } else {
                setShowBridge(false);
              }
              toast.success(t("features.feature_disabled", { feature: "ShowBridge" }));
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "ShowBridge" }));
            });
        }
      })
      .catch((error) => {});
  };
  const setShowDetectorInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setShowDetector/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setShowDetector(true);
              } else {
                setShowDetector(false);
              }
              toast.success(t("features.feature_enabled", { feature: "ShowDetector" }));
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "ShowDetector" }));
            });
        } else {
          Axios.put(`/setShowDetector/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setShowDetector(true);
              } else {
                setShowDetector(false);
              }
              toast.success(t("features.feature_disabled", { feature: "ShowDetector" }));
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "ShowDetector" }));
            });
        }
      })
      .catch((error) => {});
  };

  //SET ALLOW DEBUG PATH
  const setAllowDebugPathInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setAllowDebugPath/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setAllowDebugPath(true);
              } else {
                setAllowDebugPath(false);
              }
              toast.success(t("features.feature_enabled", { feature: "AllowDebugPath" }));
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "AllowDebugPath" }));
            });
        } else {
          Axios.put(`/setAllowDebugPath/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setAllowDebugPath(true);
              } else {
                setAllowDebugPath(false);
              }
              toast.success(t("features.feature_disabled", { feature: "AllowDebugPath" }));
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "AllowDebugPath" }));
            });
        }
      })
      .catch((error) => {});
  };

  //SET DELETE DIRAC LICENCE
  const setDeleteDiracLicenceInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setDeleteDiracLicence/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setDiracDeleteLicense(true);
              } else {
                setDiracDeleteLicense(false);
              }
              toast.success(t("features.feature_enabled", { feature: "DeleteDiracLicence" }));
              setMajCabine((prev) => !prev);
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "DeleteDiracLicence" }));
            });
        } else {
          Axios.put(`/setDeleteDiracLicence/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setDiracDeleteLicense(true);
              } else {
                setDiracDeleteLicense(false);
              }
              toast.success(t("features.feature_disabled", { feature: "DeleteDiracLicence" }));
              setMajCabine((prev) => !prev);
            })
            .catch(function (error) {
              console.log(error);
              toast.error(t("features.feature_error", { feature: "DeleteDiracLicence" }));
            });
        }
      })
      .catch((error) => {});
  };

  //SET KILL SWITCH
  const setKillSwitchUpdateInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setKillSwitch/${cabId}`, {
            data: "1",
            passwordAdmin: passwordAdmin,
            admin: realOwnerProfile.ID,
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              toast.success(t("features.feature_enabled", { feature: "KillSwitch" }));

              if (data === "1") {
                setKillSwitch(true);
                setHasChanged(true);
              } else {
                setKillSwitch(false);
                setHasChanged(true);
              }
            })
            .catch(function (error) {
              toast.error(error.response.data.msg);
            });
        } else {
          Axios.put(`/setKillSwitch/${cabId}`, {
            data: "0",
            passwordAdmin: passwordAdmin,
            admin: realOwnerProfile.ID,
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              toast.success(t("features.feature_disabled", { feature: "KillSwitch" }));

              if (data === "1") {
                setKillSwitch(true);
                setHasChanged(true);
              } else {
                setKillSwitch(false);
                setHasChanged(true);
              }
            })
            .catch(function (error) {
              toast.error(error.response.data.msg);
            });
        }
      })
      .catch((error) => {});
  };

  /* ATOMIC ZONE FONCTION QUI VERIFIE LES MOTS DE PASSE AVANT D'AFFICHER Les Fonctions protégés*/

  const authFunctionAtomic = () => {
    Axios.post(`/authFunctionAtomic/${cabId}`, {
      passwordAdmin: passwordAdmin,
      admin: realOwnerProfile.ID,
    })
      .then((response) => {
        if (response.data.isVerified) {
          setShowFunctionAtomic(true);
          toast.success(t("features.access_granted"));
        } else {
          toast.error(response.data.msg);
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la vérification", error);
        toast.error(t("features.verification_error"));
      });
  };

  const closeModal = () => {
    toggle();
    setPassWordAdmin("");

    setShowFunctionAtomic(false);
  };

  const handleCabineDelete = async () => {
    const confirmed = window.confirm(
      t("features.confirm_delete_cabine")
    );
  
    if (!confirmed) return;
  
    try {
      const { data } = await Axios.delete(`/deleteCabine/${cabId}`, {
        data: {
          passwordAdmin: passwordAdmin,
          admin: realOwnerProfile.ID,
        },
      });
  
      if (data?.error) {
        toast.error(t("features.cabine_delete_error", { error: data.error }));
        return;
      }
  
      toast.success(t("features.cabine_deleted"));
  
      // Fermer la modale si tu as une fonction comme closeModal()
      if (typeof closeModal === "function") {
        closeModal();
      }
  
      // Recharger la page après un petit délai
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      
    } catch (error) {
      console.error("Erreur suppression cabine :", error);
      toast.error(t("features.cabine_delete_error", { error: error.message }));
    }
  };
  
  return (
    <div className={styles.settingsFeatures}>
      <div className={styles.container}>
        <div className={styles.optional}>
          <h3>{t("features.debug_title")}</h3>
          <div className={styles.featuresGrid}>
          <div className={styles.name}>
            <span>ForceRepairOnQuit</span>

            <div
              // get cabId and User ID
              className={styles.containerCheckBox}
            >
              <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setForceRepairOnQuitInDb(e.target.checked)}
                checked={forceRepairOnQuit}
              /></PermissionGate>
              <label></label>
            </div>
          </div>
          <div className={styles.name}>
            <span>AskUpdate</span>

            <div
              // get cabId and User ID
              className={styles.containerCheckBox}
            >    
             <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setUpdateNextStartInDb(e.target.checked)}
                checked={updateNextStart}
              /></PermissionGate>
              <label></label>
            </div>
          </div>
          <div className={styles.name}>
            <span>ShowBridge</span>
            <div className={styles.containerCheckBox}>
               <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setShowBridgeInDb(e.target.checked)}
                checked={showBridge}
              /></PermissionGate>
              <label></label>
            </div>
          </div>
          <div className={styles.name}>
            <span>ShowDetector</span>

            <div className={styles.containerCheckBox}>
               <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setShowDetectorInDb(e.target.checked)}
                checked={showDetector}
              /></PermissionGate>
              <label></label>
            </div>
          </div>
          <div className={styles.name}>
            <span>AllowDebugPath</span>

            <div className={styles.containerCheckBox}>
               <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setAllowDebugPathInDb(e.target.checked)}
                checked={allowDebugPath}
              /></PermissionGate>
              <label></label>
            </div>
          </div>
          <div className={styles.name}>
            <span>DeleteDiracLicense</span>

            <div className={styles.containerCheckBox}>
               <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setDeleteDiracLicenceInDb(e.target.checked)}
                checked={DeleteDiracLicence}
              /></PermissionGate>
              <label></label>
            </div>
          </div>
          </div>
          {cabine && (
            <div className={styles.setLogging}>
              <span>{t("features.set_logging_level")}</span>
                <PermissionGate actionKey="cabines.setLoggingLevel">
              <select
                value={levelLog}
                onChange={(e) => changeLevelLog(e)}
                name=""
                id=""
              >
                <option value="0">None</option>
                <option value="1">Standard</option>
                <option value="2">Critical</option>
                <option value="3">Full</option>
              </select>
              </PermissionGate>
            </div>
          )}
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.optional}>
          <PermissionGate actionKey="cabines.protectedFunctions">
            <button
              type="button"
              className={styles.accessProtectedBtn}
              onClick={toggle}
            >
              <GiMushroomCloud style={{ fontSize: "16px", verticalAlign: "middle", marginRight: "6px" }} />
              {t("features.access_protected")}
            </button>
          </PermissionGate>
        </div>
      </div>

      {/* MODAL KILLSWITCH */}
      <Modal isShowing={isShowing} hide={closeModal}>
        {!showFunctionAtomic ? (
          <div className={styles.containerModal}>
            <div className={styles.avertissement}>
              <GiMushroomCloud
                title={t("features.protected_functions_title")}
                style={{
                  color: "orange",
                  cursor: "pointer",
                  fontSize: "55px",
                }}
              />
              <span>{t("features.atomic_zone_warning")}</span>
              <span className={styles.adminName}>
                {t("features.enter_password")}
              </span>
            </div>

            <div className={styles.containerInput}>
              <InputForms
                id={styles.pass1}
                placeholder={t("features.password_placeholder")}
                type="password"
                onChange={(e) => setPassWordAdmin(e.target.value)}
                required={true}
              />
            </div>

            <div className={styles.modalBtnWrap}>
              <Button
                onPress={authFunctionAtomic}
                styles="btnPrimary"
                svg={<GiOverkill />}
                text={t("features.access_protected")}
              />
            </div>
          </div>
        ) : (
          <div className={styles.protectedFunctions}>
            {/* KillSwitch */}
            <div className={styles.cardFunctionProtected}>
              <div className={styles.headerCard}>
                <GiMushroomCloud
                  style={{ color: "#FFA500", fontSize: "30px" }}
                />
                <span className={styles.titleCard}>KillSwitch</span>
              </div>

              <p className={styles.descriptionCard}>
                {t("features.killswitch_description")}
              </p>

              <div className={styles.toggleContainer}>
                <label className={styles.toggleLabel}>{t("features.enable")}</label>
                <input
                  type="checkbox"
                  onChange={(e) => setKillSwitchUpdateInDb(e.target.checked)}
                  checked={killSwitch}
                  className={styles.toggleInput}
                />
              </div>

              {hasChanged && (
                <div className={styles.containerImg}>
                  {killSwitch ? (
                    <img src="https://media.giphy.com/media/xTiIzrRyvrFijaEtY4/giphy.gif" />
                  ) : (
                    <img src="https://media.giphy.com/media/3o84sBJxpPt6g6MRdC/giphy.gif" />
                  )}
                </div>
              )}
            </div>

            {/* Suppression cabine */}
            <div className={styles.cardFunctionProtected}>
              <div className={styles.headerCard}>
                <GiMushroomCloud
                  style={{ color: "#FF4D4F", fontSize: "30px" }}
                />
                <span className={styles.titleCard}>{t("features.delete_cabine")}</span>
              </div>

              <p className={styles.descriptionCard}>
                {t("features.delete_cabine_description")}
              </p>

              <Button
                onPress={handleCabineDelete}
                styles={"btnDelete"}
                text={t("features.delete_permanently")}
              />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default UpdateFeatures;
